
// Vue reactivity
import { computed, ref } from "vue";

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonList, IonItem, IonLabel,
        IonGrid, IonRow, IonCol, IonSpinner, IonButtons, IonBackButton, IonSegment, IonSegmentButton, } from "@ionic/vue";
import ProfessionModal from '@/components/pss/ProfessionModal.vue';
import SectorModal from '@/components/pss/SectorModal.vue';

import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';
import { utils } from '@/composables/utils';
import { Profession, Sector, Segment } from '@/types';

export default {
  name: "UserBrowsedListPage",
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonList, IonItem, IonLabel,
    IonGrid, IonRow, IonCol, IonSpinner, IonButtons, IonBackButton, IonSegment, IonSegmentButton,
  },
  setup() {
    // methods or filters
    const { t } = useI18n();
    const store = useStore();
    const { openModal } = utils();
    const targetList = ref('professions');

    // 1. declare state variables (ref to make them reactive)
    const loading = computed(() => store.state.loadingPortalData);
    const professions = computed<Profession>(() => store.getters.userRecentBrowsedProfessions);
    const sectors = computed<Sector>(() => store.getters.userRecentBrowsedSectors);
    const segments = computed<Segment>(() => store.getters.userRecentBrowsedSegments);

    const openProfessionModal = async (professionId: any) => await openModal(ProfessionModal, { professionId });
    const openSectorModal = async (sectorId: any, segmentId = '') => (await openModal(SectorModal, { sectorId, segmentId }));

    // 3. return variables & methods to be used in template HTML
    return {
      // variables
      loading,
      professions, sectors, segments,
      targetList,

      // methods
      t,
      openProfessionModal, openSectorModal
    };
  },
};
